import Swiper from "swiper";

var swiper = new Swiper('.swiper-container-about-lang');
export default {
  init() {


  },
};



// WEBPACK FOOTER //
// ./scripts/routes/aboutlang.js